async function getUserMarkers() {
  return new Promise(resolve => {
    const userDefaultMarkers = [
      {
        color: '#80e1fd',
        darkColor: '#2f9ab9',
        label: 'Important',
        shared: false,
        friendsOnly: false,
        sortOrder: 1
      },
      {
        color: '#a1ec80',
        darkColor: '#56b52d',
        label: 'Definition',
        shared: false,
        friendsOnly: false,
        sortOrder: 2
      },
      {
        color: '#f4ed75',
        darkColor: '#bbac05',
        label: 'Example',
        shared: false,
        friendsOnly: false,
        sortOrder: 3
      },
      {
        color: '#ff7979',
        darkColor: '#bc2626',
        label: 'Confused',
        shared: false,
        friendsOnly: false,
        sortOrder: 4
      }
    ];

    resolve(userDefaultMarkers);
  });
}


export default getUserMarkers;
